import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignupPage from './features/auth/pages/SignupPage';
import LoginPage from './features/auth/pages/LoginPage';
import DashboardPage from './features/dashboard/pages/DashboardPage';
import AdminLayout from './layouts/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import CreateCustomerPage from './features/customer/pages/CreateCustomerPage';
import CustomerListingPage from './features/customer/pages/CustomerListingPage';
import UpdateCustomerPage from './features/customer/pages/UpdateCustomerPage';
import ShowCustomerPage from './features/customer/pages/ShowCustomerPage';
import CPAProfilePage from './features/cpa/pages/ProfilePage';
import SendCustomerEmail from './features/customer_mail/pages/SendCustomerEmail';
import CustomerEmailListingPage from './features/customer_mail/pages/CustomerEmailListingPage';
// Add toast container imports
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VerifyEmail from './features/auth/pages/VerifyEmail';
import EmailDetailsPage from './features/customer_mail/pages/EmailDetailsPage';
import ChatPage from './features/messaging/pages/ChatPage';
import MessageList from './features/messaging/pages/MessageList';
import ActivityLogPage from './features/activity_log/pages/ActivityLogPage';
import NewFeaturePage from "./features/new_feature/pages/NewFeaturePage";
import ManageWebsite from "./features//manage_website//pages/ManageWebsitePage";
import DocumentTrainingPage from './features/document_training/pages/DocumentTrainingPage';
import CustomerFinderPage from './features/customer_finder/pages/CustomerFinderPage';
import MarketingPage from "./features/marketing/pages/MarketingPage";
import { NotificationProvider } from './contexts/MessageNotificationContext';
function App() {
  return (
    <>

     <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />

          <Route path="verify-email" element={<VerifyEmail/>} />

          <Route path="/dashboard/*" element={
            <NotificationProvider>
              <ProtectedRoute allowedRoles={['cpa']}>
                <AdminLayout />
              </ProtectedRoute>
            </NotificationProvider>
          }>
            
            <Route index element={<DashboardPage />} />
            <Route path="activity-log" element={<ActivityLogPage />} />
            <Route path="new-feature" element={<NewFeaturePage />} />
            <Route path="marketing" element={<MarketingPage />} />
            <Route path="manage-website" element={<ManageWebsite />} />
            <Route path="document-training" element={<DocumentTrainingPage />} />
            <Route path="customer-finder" element={<CustomerFinderPage />} />


            <Route path="create-customer" element={<CreateCustomerPage />} />
            <Route path="customer-list" element={<CustomerListingPage />} />
            <Route path="customer/:id/edit" element={<UpdateCustomerPage />} />
            <Route path="customer/:id" element={<ShowCustomerPage />} />
            <Route path="cpa-profile" element={<CPAProfilePage />} />
            <Route path="customer-email" element={<CustomerEmailListingPage />} />
            <Route path="customer-email-detail/:id" element={<EmailDetailsPage />} />

            <Route path="send-customer-email/:id" element={<SendCustomerEmail />} />

            <Route path="chat" element={<ChatPage />} /> 
            <Route path="messages/:id" element={<MessageList />} /> 


          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
